import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface SpecialitySelectProps extends Omit<SelectProps, 'handleChange'> {
  handleChange: (value: { value: string; externalCode: string }) => void;
  chapter: { externalName: string; externalCode: string }[];
  isLoading: boolean;
}

export default function SpecialitySelect({ idPosition, chapter, isLoading, handleChange, ...rest }: Readonly<SpecialitySelectProps>) {

  const { setValue, getValues } = useFormContext();

  const options = chapter?.map(({ externalName }) => ({
    value: externalName,
    label: externalName,
  }));

  useEffect(() => {
    const currentValue = getValues(`growInformation.${idPosition}.specialty`);
    if (chapter && currentValue) {
      const selectedChapter = chapter.find(({ externalName }) => externalName === currentValue);
      if (selectedChapter) {
        setValue(`growInformation.${idPosition}.idSpecialtySap`, selectedChapter.externalCode);
        setValue(`growInformation.${idPosition}.specialty`, currentValue);
      } else {
        setValue(`growInformation.${idPosition}.idSpecialtySap`, undefined);
        setValue(`growInformation.${idPosition}.specialty`, undefined);
      }
    }
  }, [chapter, getValues, setValue]);

  return (
    <Select
      handleChange={(value) =>
        handleChange({
          value: value?.toString() ?? '',
          externalCode: chapter?.find(({ externalName }) => externalName === value)?.externalCode ?? ''
        })
      }
      disabled={isLoading}
      options={options}
      {...rest}
    />
  );
}
